module.exports = __webpack_public_path__ + "static/phone2-ca6a74939403ed0c692311499a64c8a4.png";